import * as React from 'react';

import type {
    DripSequenceGoalSetInput,
    DripSequenceGoalSetInputFieldInput,
    GetDripSequence_campaign_goal as GoalFragment,
} from 'nutshell-graphql-types';

import {AddNextStepForm} from '../sidebar/add-next-step-form';
import {DripSequenceSidebarForm} from '../sidebar/drip-sequence-sidebar-form';
import {existingGoalToConditionsArray, formDataToNextStepAction} from '../sidebar/helpers';

import type {Variant} from './color-icon-variants';
import {NextStepCard} from './next-step/next-step-card';

type Props = {
    isLoading: boolean;
    dripSequenceId: string;
    goal: GoalFragment;
    onSetGoal: (input: DripSequenceGoalSetInput) => Promise<any>;
    variant?: Variant;
};

export function NextStepCardWrapper(props: Props) {
    const [isEditingNextStep, setIsEditingNextStep] = React.useState<string | null | undefined>(
        null
    );
    const [isSaving, setIsSaving] = React.useState<boolean>(false);
    const [saveFailedErrorMessage, setSaveFailedErrorMessage] = React.useState<
        string | null | undefined
    >(undefined);

    const saveGoal = (
        dripSequenceId: string,
        variables?: DripSequenceGoalSetInputFieldInput | null
    ): Promise<any> => {
        return props
            .onSetGoal({
                campaignId: dripSequenceId,
                dripSequenceGoal: variables,
            })
            .then(() => {
                setIsEditingNextStep(null);
            })
            .catch((error) => {
                setSaveFailedErrorMessage(error.message);
            });
    };

    const existingGoalType = props.goal.type;

    return (
        <div className='mb-16'>
            <NextStepCard
                isLoading={props.isLoading}
                goal={props.goal.action ? props.goal : undefined}
                onClick={() => setIsEditingNextStep(props.goal.id)}
                variant={props.variant}
            />
            {isEditingNextStep && props.goal ? (
                <DripSequenceSidebarForm
                    title={props.goal.action ? 'Edit next step' : 'Add next step'}
                    // @ts-expect-error
                    onSubmit={(formData) => {
                        if (!formData.nextStepType) return;

                        const variables = {
                            type: existingGoalType,
                            conditions: existingGoalToConditionsArray(props.goal),
                            action: formDataToNextStepAction(formData),
                        } as const;

                        return saveGoal(props.dripSequenceId, variables);
                    }}
                    onClose={() => {
                        setSaveFailedErrorMessage(undefined);
                        setIsEditingNextStep(null);
                    }}
                    isNewItem={Boolean(!props.goal.action)}
                    existingNextStep={props.goal.action ? props.goal.action : undefined}
                    isSaving={isSaving}
                    saveFailedErrorMessage={saveFailedErrorMessage}
                    // @ts-expect-error
                    deleteProps={
                        props.goal.action
                            ? {
                                  title: 'Remove next step',
                                  buttonText: 'Remove next step',
                                  message: 'Are you sure you’d like to remove this next step?',
                                  onDelete: () => {
                                      setIsSaving(true);

                                      const variables = {
                                          type: existingGoalType,
                                          conditions: existingGoalToConditionsArray(props.goal),
                                          action: null,
                                      } as const;

                                      saveGoal(props.dripSequenceId, variables).then(() => {
                                          setIsSaving(false);
                                      });
                                  },
                              }
                            : undefined
                    }
                >
                    <AddNextStepForm />
                </DripSequenceSidebarForm>
            ) : undefined}
        </div>
    );
}
